module.exports = __webpack_public_path__ + "static/media/agentes.99926e5e.png";